<template>
	<div id="chuchModule" class="chuchModule">
		<nav class="navbar navbar-light bg-light">
			<div class="form-inline">
				<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar" aria-label="Buscar" ref="searchChurchs"
					v-model="searchChurchs"
					v-on:keyup.enter="getAllChurchs(1)"
					@focus="$event.target.select()">
				<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getAllChurchs(1)">Buscar</button>
				<div class="float-right d-none d-sm-inline separator"></div>
			</div>
			<div class="form-inline">
				<span class="mr-sm-1">Mostrar</span>
				<select class="form-control form-control-sm mr-sm-1 float-sm-right margin-right5 " id="qrows" v-model="qRowsChurch" @change="changeQRowsChurch">
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
					<option>200</option>
					<option>1000</option>
			    </select>
			</div>
		</nav>
		<table class="table table-sm table-hover">
			<thead>
				<tr>
					<th class="text-center">ID</th>
					<th class="text-center">Campo</th>
					<th class="text-center">Tipo</th>
					<th class="text-center">Nombre</th>
					<th class="text-center">Distrito</th>
					<th class="text-center">Coordinador</th>
					<th class="text-center">Dir. Envío</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in listChurchs" :key="index" @dblclick="showConsole(item)">
					<td class="text-center">{{ item.id }}</td>
					<td class="text-center" :title="item.entity.name">{{ item.entity.synthetic }}</td>
					<td>{{ item.type_church.name }}</td>
					<td>{{ item.name }}</td>
					<td>{{ item.district.name }}</td>
					<td :class="(item.client == null) ? 'text-center' : ''">
						<i class="fas fa-minus text-black-50" v-if="item.client == null"></i>
						<router-link :to="'/client/' + item.client.id" target="_blank" v-else>{{item.client.name + ' ' + item.client.surname}}</router-link>
					</td>
					<td :class="(item.client_address_send == null) ? 'text-center' : ''">
						<i class="fas fa-minus text-black-50" v-if="item.client_address_send == null"></i>
						<span v-else :title="(item.client_address_send.transport_id != null) ? item.client_address_send.transport.name : 'Sin Transporte'">{{item.client_address_send.text + ', ' + item.client_address_send.comuna}}</span>
					</td>
					<td class="text-right">
						<i class="far fa-edit text-warning pointer" title="Editar" @click="showChurchLocal(item.id)"></i>
					</td>
				</tr>
			</tbody>
		</table>
		<pagination :pagination="paginationChurchs" @getAllList="getAllChurchs"></pagination>
		<church-modal-component :id="churchId" @actionSaveChurch="saveChurchLocal" ref="churchDocumentModalComponent"></church-modal-component>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import churchs from '@/mixins/generals/church.js'

import Pagination from '@/components/Pagination.vue'
import ChurchModalComponent from '@/components/ChurchModalComponent.vue'
export default {
	name: 'Chuchs',
	mixins: [axiosAction, errors, mixin, churchs],
	data() {
		return {
			churchId: 0
		}
	},
	computed: {
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Lista de Iglesias')
			this.setSubTitleModule('')
			this.setChurchInit()
		},
		getAllChurchsResultLocal(response) {
		},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'getAllChurchsResult': this.getAllChurchsResult(response); break;
		        default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		saveChurchLocal(data) {
			if(data.message != 'NOACTUALIZADO'){
				this.updateItemListChurchs(data.data)
			}
		},
		showChurchLocal(id) {
			this.churchId = id
			this.$refs.churchDocumentModalComponent.$refs.btnShowChurchModalComponent.click()
		}
	},
	components: {
		'pagination': Pagination,
		'church-modal-component': ChurchModalComponent,
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>